import {
  fromJS,
  List,
  Map,
}                           from 'immutable';
import { handleActions }    from 'redux-actions';
import { buildListActions } from '../../../../actions/utils/apiResources/buildSyncActions';


const DATA_KEY_MEMBERS = 'hydra:member';


const buildIdsBySlugReducer = (resource) => {

  const listLoadSuccess = buildListActions(resource).success;

  return handleActions(
    {
      [listLoadSuccess](state, {payload: {receivedData}}) {

        const data = fromJS(receivedData);

        if (!(data.get(DATA_KEY_MEMBERS) instanceof List)) {

          return state;

        }

        return state.merge(
          data.get('hydra:member').reduce((accumulator, item) => {

            return accumulator.set(item.get('slug'), item.get('@id'));

          }, Map())
        );

      },
    },

    Map()
  );

};

export default buildIdsBySlugReducer;


// WEBPACK FOOTER //
// ./src/reducers/utils/apiResources/items/buildIdsBySlugReducer.js